export default __webpack_public_path__ + "static/media/Digital-Patreon-Logo.088eb115.png";